<template>
	<div>
		<Header />
		<router-view />
		<Footer />
		<div id="pagetop">
			<img src="./assets/img/top.svg" alt="TOPへ戻る"/>
		</div>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

import './assets/js/common'
import './assets/css/reset.css'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.v-application--wrap {
	min-height: calc(100vh - 262px) !important;
}
h1 {
	font-family: 'Noto Sans JP', sans-serif;
	font-size: 30px;
	font-weight: normal;
	letter-spacing: 5px;
	font-feature-settings: "palt";
}
h2 {
	font-family: neue-haas-grotesk-display, sans-serif;
	font-weight: 600;
	font-style: normal;
	line-height: 2.5;
	font-size: 38px;
	letter-spacing: 1em;
	text-transform: uppercase;
}
h3 {
	font-family: neue-haas-grotesk-display, sans-serif;
	font-weight: 600;
	font-style: normal;
	font-size: 18px;
	letter-spacing: 1px;
	text-transform: uppercase;
	line-height: 1.8;
}
h4 {
	font-family: 'Noto Sans JP', sans-serif;
	font-size: 16px;
	font-weight: bold;
	letter-spacing: 1px;
	font-feature-settings: "palt";
	color: #1A1A1A;
}
p {
	font-family: 'Noto Sans JP', sans-serif;
	font-size: 16px;
	font-weight: normal;
	font-feature-settings: "palt";
	color: #1A1A1A;
	line-height: 2;
	letter-spacing: 2px;
}
dt {
	font-family: 'Noto Sans JP', sans-serif;
	font-size: 16px;
	font-weight: 700;
	font-feature-settings: "palt";
	color: #1A1A1A;
	line-height: 2;
	letter-spacing: 2px;
}
.sp_only {
	display: none;
}
.pc_only {
	display: block;
}

#pagetop {
	position: fixed;
	bottom: 0px;
	right: 30px;
	z-index: 6;
}
#pagetop img {
	height: 60px;
}

@media screen and (max-width: 821px) {
	.sp_only {
		display: block;
	}
	.pc_only {
		display: none;
	}
	/*---- FAQ----*/
	.qa-list,.partner {
		max-width: 700px;
	}
}

/*-----ipad mini------*/
@media screen and (max-width: 770px) {
	.mv_contents_box_title h1 {
		margin: 20px auto 20px;
	}
}

/*-----iPhoneX_12pro------*/
@media screen and (max-width: 599px) {
	/*---- header----*/
	.mv_contents_box {
		bottom: 8%;
	}
	.mv_contents_box {
		width: 100%;
	}
	.mv_contents_box a {
		font-size: 14px;
		width: 48%;
	}
	.mv img {
		width: 220px;
	}
	.mv_contents_box_title {
		margin-bottom: 18px;
	}
	.mv_contents_box_btn {
   	margin: auto;
	}
	h1 {
		font-size: 20px;
		letter-spacing: 4px;
	}
	.mv_contents_box_btn {
		max-width: 320px;
	}
	/*---- about----*/
	.about_contents, .product_contents, .spec,.qa-list, .partner, .partner_contents {
		max-width: 350px;
	}
	.about_contents img {
		width: 315px;
	}

	/*---- product----*/
	.product h2,.use_case h2,.qa-list h2,.partner h2,.contact h2 {
		font-size: 28px;
		padding-left: 30px;
		box-sizing: border-box;
	}
	.product_contents_box {
		width: 47%;
	}
	.product_contents_box p {
		letter-spacing: 0px;
	}
	.product_contents_back {
		height: 90%;
	}
	.spec {
		flex-wrap: wrap;
	}
	.spec_box {
		width: 30%;
	}
	.spec_box h3 {
		height: 100%;
		line-height: 1.3;
	}

	/*---- case----*/
	.swiper-slide {
		padding: 50px 10%;
	}
	.use_case {
		padding-top: 10px;
	}
	.use_case_contents_box {
		padding: 25px 28px;
	}
	.swiper-slide h4 {
		font-size: 19px;
	}
	.swiper-button-next, .swiper-container-rtl .swiper-button-prev,.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
		width: 10%!important;
	}
	.use_case_contents_box_img {
		height: 50%;
	}
	.use_case_contents_box_text {
		height: 45%;
	}
	.footer_contents {
		margin: auto;
	}
	.contact_contents_box {
		margin: auto;
		flex-direction: column-reverse;
	}
	.contact_contents_back {
		clip-path: polygon(0 70%, 100% 50%, 100% 100%, 0 100%);
    width: 100%;
	}
	.contact_contents {
		height: 750px;
	}
	.contact_contents_box_text .mv_contents_box_btn {
		margin-top: 30px;
		margin-bottom: 50px;
	}
	.contact_contents_box_text .mv_contents_box_btn a {
		width: 48%;
	}
	.partner_contents img {
		height: 50px;
	}
	.qa-list,.partner {
		margin: 90px auto 100px;
	}
	.qa-list dl dd {
		padding: 0;
	}
}

/*-----iPhoneSE------*/
@media screen and (max-width: 376px) {
	.use_case h2 {
		font-size: 27px;
	}
	.swiper-slide h4 {
		font-size: 18px;
	}
	.use_case_contents_box_img {
		height: 40%;
	}
	.use_case_contents_box_text {
		height: 53%;
	}
}

</style>
